export const BRAND = 'PredictIt';

export default {
  data() {
    return {
      brand: BRAND,
    };
  },
};
